<form nz-form class="form" [formGroup]="filterForm" nzLayout="horizontal">
  <!-- Zoho-style compact navigation bar -->
  <div class="graph-filter-bar">
    <!-- LEFT: Timeline label + date navigation -->
    <div class="filter-bar-left">
      <span class="bar-timeline-label">Timeline</span>
      <div class="bar-nav-controls">
        <button
          type="button"
          class="bar-nav-btn"
          aria-label="Previous range"
          (click)="onNavigateRange('prev')">
          <span class="nav-chevron">&#8249;</span>
        </button>

        <button
          #dateBarTrigger
          class="bar-date-trigger"
          type="button"
          tabindex="0"
          aria-label="Open date range picker"
          (click)="togglePopover()">
          <span class="bar-date-text">{{ selectedRangeDisplay }}</span>
          <span class="bar-date-meta" *ngIf="selectedRangeMetaLabel">
            ({{ selectedRangeMetaLabel }})
          </span>
          <svg-icon
            [title]="'Select Date'"
            src="/assets/icon/icon-calendar.svg"
            class="icon s-16 bar-calendar-icon"
            aria-label="Calendar"></svg-icon>
        </button>

        <button
          type="button"
          class="bar-nav-btn"
          aria-label="Next range"
          (click)="onNavigateRange('next')">
          <span class="nav-chevron">&#8250;</span>
        </button>
      </div>
    </div>

    <!-- RIGHT: View Type + Trend toggle -->
    <div class="filter-bar-right">
      <div class="filter-bar-field">
        <span class="bar-timeline-label">View Type</span>
        <nz-select
          class="bar-view-type"
          nzPlaceHolder="View Type"
          formControlName="viewType"
          [nzOptionOverflowSize]="7">
          <nz-option
            *ngFor="let item of enabledViewTypeOptions"
            [nzLabel]="item.label"
            [nzValue]="item.value">
          </nz-option>
        </nz-select>
      </div>

      <div class="filter-bar-field">
        <span class="bar-timeline-label">&nbsp;</span>
        <div class="bar-trend-toggle">
          <nz-switch formControlName="isTrendLineEnabled"> </nz-switch>
          <span class="bar-trend-text">Show Trend Line</span>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- Popover rendered outside root via CDK Overlay -->
<ng-template #popoverTpl>
  <div class="filter-popover">
    <!-- Tabs: Day / Week / Month / Quarter / Year / Range + Close -->
    <div class="popover-tabs">
      <button
        *ngFor="let opt of timeRangeOptions"
        type="button"
        class="popover-tab"
        [class.active]="tempTimeOption === opt.value"
        (click)="onPopoverTabChange(opt.value)">
        {{ opt.label }}
      </button>
    </div>

    <!-- Calendar / picker area -->
    <div class="popover-body">
      <ng-container *ngIf="tempTimeOption === 5; else singlePickerTpl">
        <nz-range-picker
          id="popover-range"
          class="popover-picker"
          [nzFormat]="dateFormat"
          [(ngModel)]="tempDateRange"
          [ngModelOptions]="{ standalone: true }"
          [nzAllowClear]="false"
          [nzInline]="true">
        </nz-range-picker>
      </ng-container>

      <ng-template #singlePickerTpl>
        <nz-date-picker
          id="popover-single"
          class="popover-picker"
          [nzMode]="getTempPickerMode()"
          [nzFormat]="dateFormat"
          [(ngModel)]="tempSingleDate"
          [ngModelOptions]="{ standalone: true }"
          [nzAllowClear]="false"
          [nzInline]="true">
        </nz-date-picker>
      </ng-template>
    </div>

    <!-- Footer: shortcut + OK / Cancel -->
    <div class="popover-footer">
      <button
        type="button"
        class="popover-shortcut-btn"
        (click)="goToCurrentPeriod()">
        {{ currentPeriodLabel }}
      </button>
      <div class="popover-actions">
        <button
          type="button"
          nz-button
          nzType="primary"
          nzSize="small"
          (click)="applyPopover()">
          OK
        </button>
        <button
          type="button"
          nz-button
          nzType="default"
          nzSize="small"
          (click)="cancelPopover()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
